import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { Header } from '../components/Header';
import { Loading } from '../components/Loading';
import { TextOnly, Text } from '../components/Text';
import { getOemHealth } from '../libs/db-lib';

const OemHealth = () => {
  const [search, setSearch] = useState<string>('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const [oemListData, setOemListData] = useState<any[]>([]);

  const formatLast7DaysDate = (day: string) => {
    const [parsedYear, parsedMonth, parsedDay] = day.split('/');

    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const month = months[Number(parsedMonth) - 1] ?? 'invalid';

    if (month !== 'invalid') {
      return `${month} ${parsedDay}, ${parsedYear}`;
    } else {
      return `${parsedDay}/${parsedMonth}/${parsedYear}`;
    }
  };

  const formatLast24HoursDate = (day: string) => {
    const [parsedDay, parsedHour] = day.split('/').map(Number);

    const now = new Date();
    const year = now.getUTCFullYear();

    let monthIndex = now.getUTCMonth();
    if (parsedDay > now.getUTCDate()) {
      monthIndex -= 1;
      if (monthIndex < 0) monthIndex = 11;
    }

    const utcDate = new Date(
      Date.UTC(year, monthIndex, parsedDay, parsedHour, 0, 0)
    );

    return utcDate.toLocaleString(undefined, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short',
    });
  };

  const getOemList = (data: any) => {
    const oemList = data?.oemList?.map((oem: any) => {
      return {
        oemName: oem?.oemName,
        regionName: oem?.regionName,
        last24Hours: oem?.last24Hours,
        last7Days: oem?.last7Days,
        filterString: `${oem?.oemName} ${oem?.regionName}`.toLowerCase(),
      };
    });
    return oemList;
  };

  const { data: oemList, isLoading: isLoadingOemList } = useQuery(
    `getOemHealth`,
    () => getOemHealth()
  );

  useEffect(() => {
    setOemListData(getOemList(oemList || { oemList: [] }));
  }, [oemList]);

  if (isLoadingOemList) {
    return <Loading />;
  }

  return (
    <>
      <Header title={TextOnly('oemHealth')} />
      <div className="l-container">
        <div className="l-flex-wrap">
          <div className="l-flex-row-wrap">
            <div className="l-flex-align-items-center u-margin-right">
              {TextOnly('key')}:
            </div>
            <div className={`oem-service-level oem-service-level--good`}>
              {TextOnly('good')}
            </div>
            <div className={`oem-service-level oem-service-level--degraded`}>
              {TextOnly('degraded')}
            </div>
            <div className={`oem-service-level oem-service-level--down`}>
              {TextOnly('down')}
            </div>
          </div>
          <div className="l-flex-end">
            <div className="c-field u-margin-bottom-none">
              <label htmlFor="search" className="c-field__label u-is-vishidden">
                <Text tid="search" />
              </label>
              <input
                type="text"
                id="search"
                maxLength={50}
                className="c-input"
                placeholder={TextOnly('search')}
                value={search}
                onChange={handleChange}
              />
              <i className="c-field__input-icon fal fa-search" />
            </div>
          </div>
        </div>

        <div className="u-margin-top-large">
          {oemListData
            ?.filter((oem: any) =>
              oem?.filterString?.includes(search?.toLowerCase())
            )
            ?.map((oem: any, idx: number) => (
              <div
                className="c-stats-widget u-max-width-none u-margin-bottom-large"
                key={`${idx}-${oem?.oemID}`}
              >
                <div className="h2 c-stats-widget__title u-margin-top-large">
                  {oem?.oemName} - {oem?.regionName}
                </div>
                <div className="l-flex-column u-margin-top-large u-margin-bottom-large">
                  <div className="c-stats-widget__label">
                    {TextOnly('last24Hours')}
                  </div>
                  <div className="l-flex-row-wrap">
                    {oem?.last24Hours?.map((status: any, idx: number) => (
                      <div
                        className={`oem-service-level oem-service-level--${status?.serviceLevel?.toLowerCase()}`}
                        key={`${idx}-${status?.date}`}
                      >
                        {formatLast24HoursDate(status?.date)}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="l-flex-column u-margin-top-large u-margin-bottom-large">
                  <div className="c-stats-widget__label">
                    {TextOnly('last7Days')}
                  </div>
                  <div className="l-flex-row-wrap">
                    {oem?.last7Days?.map((status: any, idx: number) => (
                      <div
                        className={`oem-service-level oem-service-level--${status?.serviceLevel?.toLowerCase()}`}
                        key={`${idx}-${status?.date}-last7Days`}
                      >
                        <div className="l-flex-column">
                          <div className="">
                            {formatLast7DaysDate(status?.date)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default OemHealth;
